import { QRCodeSVG } from 'qrcode.react';
import { NAVY, GOLD, CREAM } from './config';

// On-screen preview of each banner format (mirrors the canvas output)
export const BannerPreview = ({ banner, fullName, agency, city, publicUrl, tagline }) => {
    const aspect = banner.width / banner.height;
    const previewW = banner.layout === 'portrait' ? 220 : banner.layout === 'card' ? 360 : 460;
    const previewH = previewW / aspect;

    if (banner.layout === 'portrait') {
        return (
            <div
                className="relative rounded-xl overflow-hidden shadow-lg flex flex-col items-center text-center text-white p-4"
                style={{ width: previewW, height: previewH, background: `linear-gradient(180deg, ${NAVY}, #1a2d52)` }}
                data-testid="banner-preview"
            >
                <p className="text-scalimmo-gold font-bold text-xs">SCALIMMO</p>
                <p className="text-white/60 text-[8px] mb-2">La plateforme des agents</p>
                <p className="font-bold text-sm uppercase leading-tight px-1 mb-2">{tagline}</p>
                <div className="bg-white p-2 rounded-lg">
                    <QRCodeSVG value={publicUrl} size={Math.min(previewW * 0.55, 140)} level="M" fgColor={NAVY} />
                </div>
                <p className="text-scalimmo-gold text-[10px] mt-2">▼ Scannez ▼</p>
                <div className="mt-auto">
                    <p className="font-bold text-sm">{fullName}</p>
                    <p className="text-[10px] text-white/70">{[agency, city].filter(Boolean).join(' · ')}</p>
                </div>
            </div>
        );
    }
    if (banner.layout === 'card') {
        return (
            <div
                className="relative rounded-xl overflow-hidden shadow-lg flex"
                style={{ width: previewW, height: previewH, backgroundColor: CREAM }}
                data-testid="banner-preview"
            >
                <div className="flex flex-col items-center justify-center p-3" style={{ width: '42%', backgroundColor: NAVY }}>
                    <p className="text-scalimmo-gold font-bold text-[10px] mb-1">SCALIMMO</p>
                    <div className="bg-white p-1.5 rounded">
                        <QRCodeSVG value={publicUrl} size={previewH * 0.55} level="M" fgColor={NAVY} />
                    </div>
                </div>
                <div className="flex-1 p-4 flex flex-col">
                    <p className="font-bold text-scalimmo-navy text-sm">{fullName}</p>
                    <p className="text-scalimmo-gold text-[8px] uppercase tracking-wider">Agent immobilier</p>
                    {agency && <p className="text-scalimmo-navy text-xs mt-1">{agency}</p>}
                    {city && <p className="text-muted-foreground text-[10px]">📍 {city}</p>}
                    <p className="text-scalimmo-navy font-semibold text-xs mt-3 leading-tight">Scannez pour prendre RDV</p>
                    <p className="mt-auto text-scalimmo-gold text-[9px] font-bold">▶ SCALIMMO.FR</p>
                </div>
            </div>
        );
    }
    // landscape
    return (
        <div
            className="relative rounded-xl overflow-hidden shadow-lg"
            style={{ width: previewW, height: previewH, backgroundColor: CREAM }}
            data-testid="banner-preview"
        >
            <div className="flex justify-between items-center p-2" style={{ backgroundColor: NAVY, height: '22%' }}>
                <div>
                    <p className="text-scalimmo-gold font-bold text-xs">SCALIMMO</p>
                    <p className="text-white/70 text-[8px]">Plateforme agents immobiliers</p>
                </div>
                <p className="text-scalimmo-gold text-[9px] font-bold">★ AGENT VÉRIFIÉ</p>
            </div>
            <div style={{ height: 3, backgroundColor: GOLD }} />
            <div className="flex p-3" style={{ height: '78%' }}>
                <div className="flex-1 flex flex-col justify-center pr-2">
                    <p className="font-bold text-scalimmo-navy text-xs leading-tight uppercase">SCANNEZ POUR VOIR MON PLANNING</p>
                    <p className="font-bold text-scalimmo-gold text-sm mt-2">{fullName}</p>
                    <p className="text-[9px] text-muted-foreground">{[agency, city].filter(Boolean).join(' · ')}</p>
                </div>
                <div className="bg-white p-1.5 rounded shadow self-center">
                    <QRCodeSVG value={publicUrl} size={previewH * 0.55} level="M" fgColor={NAVY} />
                </div>
            </div>
            <div className="absolute bottom-0 left-0 right-0 text-center text-scalimmo-navy font-bold text-[8px] py-1" style={{ backgroundColor: GOLD }}>
                PRENDRE RDV EN 1 MIN · SCALIMMO.FR
            </div>
        </div>
    );
};
